import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import {
  getFolderTreeHierarchy,
  folderHasChildrenByTotals,
  folderHasChildren,
} from '../../util/album-folder';
import DropdownMenu from '../global/DropdownMenu';
import DiscoverAlbumFolderRequestAlbumModal from './DiscoverAlbumFolderRequestAlbumModal';
import AngleDownIcon from '../icons/AngleDownIcon';
import FolderIcon from '../icons/FolderIcon';

class DiscoverAlbumFolderNavigation extends Component {
  static propTypes = {
    rootAlbumFolder: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    currentAlbumFolder: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    loading: PropTypes.bool,
    history: PropTypes.shape({
      push: PropTypes.func,
    }),
  };

  constructor(props) {
    super(props);

    const { rootAlbumFolder, currentAlbumFolder } = this.props;

    const albumFolderHierarchy = getFolderTreeHierarchy(
      currentAlbumFolder,
      rootAlbumFolder,
    );

    this.state = {
      albumFolderHierarchy,
    };
  }

  componentDidMount() {
    this.scrollToRight();
  }

  componentDidUpdate(prevProps) {
    const { currentAlbumFolder, rootAlbumFolder } = this.props;

    if (!currentAlbumFolder || !rootAlbumFolder) {
      return;
    }

    if (
      !prevProps.currentAlbumFolder ||
      !prevProps.rootAlbumFolder ||
      currentAlbumFolder.id !== prevProps.currentAlbumFolder.id ||
      rootAlbumFolder.id !== prevProps.rootAlbumFolder.id
    ) {
      const albumFolderHierarchy = getFolderTreeHierarchy(
        currentAlbumFolder,
        rootAlbumFolder,
      );
      // eslint-disable-next-line
      this.setState(
        () => ({
          albumFolderHierarchy,
        }),
        () => {
          this.scrollToRight();
        },
      );
    }
  }

  scrollToRight = () => {
    if (this.scroller) {
      this.scroller.scrollLeft = 9999;
    }
  };

  renderAlbumFolderDropdown = (albumFolder, parentAlbumFolder) => {
    if (!parentAlbumFolder) {
      return null;
    }

    const children = parentAlbumFolder?.children.album_folders?.records ?? [];
    if (children.length === 0) {
      return null;
    }

    return (
      <DropdownMenu
        key={albumFolder.id}
        toggle={
          <h3 className="text-primary mb-0">
            <FolderIcon color="#0d84fe" className="mr-1" size={16} />
            {albumFolder.name}{' '}
            <AngleDownIcon color="#0d84fe" className="ml-1" width={16} />
          </h3>
        }
        positionFixed
        toggleClassName="mr-1 flex-shrink-0"
      >
        {children.map(childAlbumFolder =>
          folderHasChildren(childAlbumFolder) ||
          folderHasChildrenByTotals(childAlbumFolder) ? (
            <Link
              to={`/discover/album-folder/${childAlbumFolder.id}/select`}
              className="dropdown-item"
              key={childAlbumFolder.id}
            >
              {childAlbumFolder.name}
            </Link>
          ) : null,
        )}
      </DropdownMenu>
    );
  };

  render() {
    const { rootAlbumFolder, currentAlbumFolder, loading } = this.props;

    const { albumFolderHierarchy } = this.state;

    if (loading || !rootAlbumFolder || !currentAlbumFolder) {
      return null;
    }

    if (currentAlbumFolder.id === rootAlbumFolder.id || !albumFolderHierarchy) {
      return null; // No hierarchy to show.
    }

    return (
      <div
        className="discover-album-folder-navigation horizontal-scroller pb-0 pr-1"
        ref={ref => {
          this.scroller = ref;
        }}
      >
        {albumFolderHierarchy.map((albumFolder, index) => {
          // New design looks odd with full hierarchy. Keep only last item
          if (albumFolder.id !== currentAlbumFolder.id) return null;
          return this.renderAlbumFolderDropdown(
            albumFolder,
            index === 0 ? undefined : albumFolderHierarchy[index - 1],
          );
        })}

        <DiscoverAlbumFolderRequestAlbumModal
          albumFolder={currentAlbumFolder}
        />
      </div>
    );
  }
}

export default DiscoverAlbumFolderNavigation;
